import { createContext } from 'react';

export const CityContext = createContext(null);
